import { render, staticRenderFns } from "./BlocklistTable.vue?vue&type=template&id=4768c081"
import script from "./BlocklistTable.vue?vue&type=script&lang=js"
export * from "./BlocklistTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports